import Tile from "@mapmycustomers/shared/types/territory/Tile";

import getTileXYByCoordinatesAndZoomLevel from "./getTileXYByCoodinatesAndZoomLevel";

const getTilesForBounds = (bounds: google.maps.LatLngBounds, zoom: number): Tile[] => {
  const [xWest, ySouth] = getTileXYByCoordinatesAndZoomLevel(
    bounds.getSouthWest().lng(),
    bounds.getSouthWest().lat(),
    zoom
  );
  let [xEast, yNorth] = getTileXYByCoordinatesAndZoomLevel(
    bounds.getNorthEast().lng(),
    bounds.getNorthEast().lat(),
    zoom
  );

  // max X coordinate for the given zoom level
  const xMax = Math.pow(2, zoom);
  if (xWest > xEast) {
    // if our current viewport crosses International Date Line, then we need to iterate
    // from xWest to xMax and then from 0 to xEast
    // instead of doing two iterations, we're just extending the range so that xEast becomes >= xWest
    // and then using modulo in the loop below
    xEast += xMax;
  }
  const tiles: Tile[] = [];
  for (let x = xWest; x <= xEast; x++) {
    for (let y = yNorth; y <= ySouth; y++) {
      tiles.push(`${zoom}_${x % xMax}_${y}`);
    }
  }

  console.debug("Viewport tile bounds", zoom, { xEast, xWest, yNorth, ySouth }, tiles);
  return tiles;
};

export default getTilesForBounds;
